import { useMemo } from 'react';
import { useCurrentUser } from '../services/userHooks';
import type { Folder } from '../types/api';

/** IDs identify folders; legacy slug-only links are accepted only when unambiguous. */
export function useFolderByRouteId(
  routeId: string,
  allowLegacySlug = false,
): Folder | undefined {
  const { currentUser } = useCurrentUser();

  return useMemo(() => {
    if (!currentUser?.folders || !routeId) return undefined;
    const folder = currentUser.folders.find((folder) => folder.id === routeId);
    if (folder || !allowLegacySlug || /^\d+$/.test(routeId)) return folder;
    const matches = currentUser.folders.filter((folder) => folder.slug === routeId);
    return matches.length === 1 ? matches[0] : undefined;
  }, [currentUser?.folders, routeId, allowLegacySlug]);
}
